module.exports = __webpack_public_path__ + "img/crecer.e7e40a89.png";